import React, { useEffect, useState } from 'react';
import { PurchaseButton } from './PurchaseButton';
import { CountdownTimer } from './CountdownTimer';
export function StickyCtaBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  const handleScrollToPrice = () => {
    const compraSection = document.getElementById('compra');
    if (compraSection) {
      // Scroll to position the section title right below the red banner
      const yOffset = -60; // Adjusted offset to show title below sticky banner
      const y = compraSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  return <div className="fixed bottom-0 left-0 w-full bg-white/95 backdrop-blur-sm border-t border-emerald-100 shadow-[0_-2px_10px_rgba(0,0,0,0.05)] z-50 py-2 px-4" data-id="element-86">
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-3" data-id="element-87">
        <div className="hidden md:flex flex-col" data-id="element-88">
          <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-89">
            Oferta limitada
          </span>
          <div className="flex items-baseline gap-1.5" data-id="element-90">
            <span className="text-lg font-black text-emerald-600" data-id="element-91">$12.99</span>
            <span className="text-xs text-gray-400 line-through" data-id="element-92">$49.99</span>
          </div>
        </div>

        <div className="hidden lg:block" data-id="element-93">
          <CountdownTimer variant="minimal" data-id="element-94" />
        </div>

        <button onClick={handleScrollToPrice} className="group flex items-center gap-2 bg-emerald-600 hover:bg-emerald-500 text-white font-semibold text-sm px-4 py-2 rounded-lg shadow-sm hover:shadow transition-all" data-id="element-95">
          <span data-id="element-96">Obtener Ahora</span>
          <svg className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-97">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-98" />
          </svg>
        </button>
      </div>
    </div>;
}